import { Box, createTheme, Stack, ThemeProvider, Typography } from "@mui/material";
import { Component } from "react";
import CircleIcon from '@mui/icons-material/Circle';
import styles from '../../../../assets/css/components/RoomInfo.module.css';

export default class TournamentInformation extends Component {
    darkTheme = createTheme({
        palette: {
            mode: "dark",
            primary: {
                main: "#F93751",
            },
        },
        typography: {
            fontFamily: 'Inter, serif',
        },
    });

    render() {
        return (
            <ThemeProvider theme={this.darkTheme}>
                <Box sx={{ display: 'flex', flexDirection: 'column', color: 'white', height: 'calc(100% - 115px)', backgroundColor: '#2a2b32', mb: '15px' }}>
                    <Stack sx={{ height: '100%' }}>
                        <Typography variant="h6" align="center" className={styles.boxTitle}>Tournament Info</Typography>
                        <Typography align="center" className={styles.placeholder}>No tournament selected</Typography>
                    </Stack>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', color: 'white', height: '100px', backgroundColor: '#2a2b32', p: '20px', boxSizing: 'border-box' }}>
                    <Stack sx={{ height: '100%' }}>
                        <Typography style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}><CircleIcon sx={{ width: '10px', height: '10px', color: '#3A3D50', mr: '10px' }}/>Tournament you clicked on</Typography>
                        <Typography style={{ display: 'flex', alignItems: 'center' }}><CircleIcon sx={{ width: '10px', height: '10px', color: '#2E6F6B', mr: '10px' }}/>Tournament you are registered for</Typography>
                    </Stack>
                </Box>
            </ThemeProvider>
        );
    }
}
